/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UpdateRackPlaceRequest } from './update-rack-place-request';


export interface UpdateRackShelfRequest { 
    id?: string | null;
    name?: string | null;
    number?: number;
    socketTypeId?: number;
    places?: Array<UpdateRackPlaceRequest> | null;
}

